<template>
  <div id="manageRole" class="Content-Page">
    <div id="namePage" class="wrap-Main">
      <div class="box-S4 flex-between-center">
        <div class="N-Page T-size-36">Manage Microsoft Role</div>
        <v-btn class="theme-btn-even" @click.stop="addItem()">
          <span class="I-create"></span>
          <span>Add Microsoft role</span>
        </v-btn>
      </div>
    </div>
    <div id="tableData" class="wrap-Main">
      <div class="box-S4">
        <v-data-table :headers="headers" :items="itemsdata">
          <template v-slot:item.action="{ item }" class="text-xs-right">
            <div class="b-action">
              <div class="b-btn">
                <v-btn fab class="btn-edit" @click="editItem(item)">
                  <span class="I-edit"></span>
                </v-btn>
                <v-btn fab class="primary btn-delete" @click="deleteItem(item)">
                  <span class="I-bin"></span>
                </v-btn>
              </div>
            </div>
          </template>
        </v-data-table>
      </div>
    </div>

    <!-- dialog สำหรับ เพิ่ม และ แก้ไข -->
    <v-dialog v-model="dialogEvent" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <!-- set form กรอกข้อมูลที่นี้ -->
              <v-flex>
                <v-text-field
                  v-model="formModel.email"
                  label="Email"
                ></v-text-field>
                <div class="b-row">
                  <div class="box-S4">
                    <v-select
                      :items="itemsListRole"
                      item-text="r_name"
                      item-value="r_id"
                      v-model="formModel.role"
                      class="hideMessage"
                      label="Role"
                    ></v-select>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="closeDialog">Cancel</v-btn>
          <v-btn :loading="loading" @click="saveToServer">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- dialog สำหรับลบ -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Delete Confirmation</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex
                >Delete "{{ formModel[Object.keys(formModel)[1]] }}" ?</v-flex
              >
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="closeDialog">Cancel</v-btn>
          <v-btn :loading="loading" @click="deleteToServer">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div id="partBack" class="wrap-Main">
      <div class="line"></div>
      <div class="box-S4">
        <v-btn text class="ColorTheme-S white--text theme-btn" @click="Back()">
          <span class="I-back"></span>
          <span>Back</span>
        </v-btn>
      </div>
    </div>
  </div>
</template>


<script>
import feathersClientUOA from "../plugins/feathers-client-uoa";
export default {
  data: () => ({
    headers: [
      { value: "email", text: "Email", sortable: true },
      { value: "role.r_name", text: "Role", sortable: true },
      { value: "action", text: "", sortable: false },
    ],
    defaultValue: {
      r_name: "",
    },
    query: { $sort: { r_id: -1 } },
    //--end config
    itemsdata: [],
    loading: false,
    dialogEvent: false,
    dialogDelete: false,
    formModel: {},
    itemsListRole:[],
    mode: "", // มีได้ 2 แบบคือ create กับ edit
  }),
  computed: {
    formTitle() {
      return this.mode === "create" ? "Add" : "Edit";
    },
  },
  async mounted() {
    //init here
    this.renderUI();
  },
  methods: {
    Back() {
      this.$router.go(-1);
    },
    async SelectListRole() {
      try {
        const q = {};
        var res = await feathersClientUOA.service("role").find({ query: q });
        this.itemsListRole = res.data;
        this.formModel.role = this.itemsListRole[0];
      } catch (error) {
        console.log(error);
        alert("ไม่สามารถขอข้อมูลจาก server ได้");
      }
    },
    async renderUI() {
      this.SelectListRole();
      try {
        const q = {};
        q.$eager = "[role]";
        var res = await feathersClientUOA
          .service("microsoftrole")
          .find({ query: q });
        this.itemsdata = res.data;
      } catch (error) {
        console.log(error);
        alert("ไม่สามารถขอข้อมูลจาก server ได้");
      }
    },
    async addItem() {
      this.mode = "create";
      this.formModel = Object.assign({}, this.defaultValue);
      await this.SelectListRole();
      this.dialogEvent = true;
    },

    async editItem(item) {
      this.mode = "edit";
      this.formModel.id = item.id;
      this.formModel.email = item.email; 
      this.formModel.role = { r_id: item.role.r_id, r_name:item.role.r_name };
      this.dialogEvent = true;
    },
    async deleteItem(item) {
      this.formModel = Object.assign({}, item);
      this.dialogDelete = true;
    },

    closeDialog() {
      this.dialogEvent = false;
      this.dialogDelete = false;
    },
    async saveToServer() {
      // const valid = await this.$validator.validateAll();
      // if (!valid) {
      //   return;
      // }
      this.loading = true;
      if (this.mode === "edit") {
        try {
          let dataEdit = {
            email: this.formModel.email,
            r_id: this.formModel.role.r_id,
          };

          if(dataEdit.r_id == undefined){
            dataEdit.r_id = this.formModel.role;
          }

          await await feathersClientUOA
            .service("microsoftrole")
            .patch(this.formModel.id, dataEdit);
          this.renderUI();
        } catch (err) {
          console.log(err);
        } finally {
          this.loading = false;
        }
      } else {
        //Add Data
        try {
          let dataAdd = {
            email:this.formModel.email,
            r_id: this.formModel.role.r_id,
          };

          if(dataAdd.r_id == undefined){
            dataAdd.r_id = this.formModel.role;
          }

          await feathersClientUOA.service("microsoftrole").create(dataAdd);
          this.renderUI();
        } catch (err) {
          console.log(err);
        } finally {
          this.loading = false;
        }
      }
      this.closeDialog();
    },
    async deleteToServer() {
      this.loading = true;
      try {
        let dataDelete = {};
        await feathersClientUOA
          .service("microsoftrole")
          .remove(this.formModel.id, dataDelete);
        this.renderUI();
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
        this.dialogDelete = false;
      }
    },
  },
};
</script>